"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerStreamsSchema = void 0;
exports.PartnerStreamsSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/partner-streams.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "PartnerStreams",
    "description": "The streams that are exclusively available on our partners' platforms. Streaming partnerships are specified by country, and time bound. Once the stream has ended, it can be viewed on our owned platforms after a contractually defined time period",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:partner-streams"
            ]
        },
        "regionalPartnerStreams": {
            "type": "array",
            "description": "A list of partner streams, each targeted to a specific country. Each partner stream represents a unique streaming partnership, detailing the partner, the targeted country, and the exclusive streaming duration.",
            "items": {
                "anyOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/partner-hosted-live-stream.schema.json"
                    }
                ]
            }
        },
        "liveStreamEndedAt": {
            "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
            "description": "The timestamp marking the end of the live stream. This is used to calculate when the stream can be made available on our owned platforms, based on the post-stream exclusive duration that has been contractually defined. Field is set by the live ops sync."
        }
    },
    "required": [
        "type",
        "regionalPartnerStreams"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1zdHJlYW1zLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvcGFydG5lci1zdHJlYW1zLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9CQUFvQixHQUFHO0lBQ2xDLEtBQUssRUFBRSx3RUFBd0U7SUFDL0UsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZ0JBQWdCO0lBQ3pCLGFBQWEsRUFBRSxzUEFBc1A7SUFDclEsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNEJBQTRCO2FBQzdCO1NBQ0Y7UUFDRCx3QkFBd0IsRUFBRTtZQUN4QixNQUFNLEVBQUUsT0FBTztZQUNmLGFBQWEsRUFBRSxtTkFBbU47WUFDbE8sT0FBTyxFQUFFO2dCQUNQLE9BQU8sRUFBRTtvQkFDUDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsTUFBTSxFQUFFLG1GQUFtRjtxQkFDNUY7aUJBQ0Y7YUFDRjtTQUNGO1FBQ0QsbUJBQW1CLEVBQUU7WUFDbkIsTUFBTSxFQUFFLGtFQUFrRTtZQUMxRSxhQUFhLEVBQUUsK1BBQStQO1NBQy9RO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sd0JBQXdCO0tBQ3pCO0NBQ0YsQ0FBQSJ9